export const getPlaceDetails = (placeId: string): Promise<google.maps.places.PlaceResult> => {
	return new Promise((resolve, reject) => {
		const service = new google.maps.places.PlacesService(document.createElement('div'))
		service.getDetails({ placeId, fields: ['address_components'] }, (place, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK && place) {
				resolve(place)
			} else {
				reject(new Error(`Place details request failed: ${status}`))
			}
		})
	})
}
